import { Component ,OnInit} from '@angular/core';
import { ApiService, NotificationService } from "@anadolu-commons/tohum-ui";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private apiService: ApiService, private notificationService: NotificationService) {
  }

  ngOnInit(): void {
    this.apiService.error$.subscribe(error => {
      if (error.statusCode === 400) {
        this.hataVer('Hata', 'Geçersiz İstek');
      }

      else if (error.statusCode === 401) {
        this.hataVer('Hata', 'Sayfaya giriş yetkiniz bulunmamaktadır.');
      }

      else if (error.statusCode === 500) {
        this.hataVer('Hata', 'Sistemde hata oluştu.');
      }

      else {

        let text = '';
        let jsonData = error.json;
        for (const item of jsonData.detail.messages) {
          text += item.message + ((jsonData.detail.messages.length > 1) ? ',' : '');
        }

        this.hataVer('Hata', text);
      }      
    });
  }

  private hataVer(baslik: string, mesaj: string) {

    this.notificationService.error({
      title: baslik,
      msg: mesaj,
      showClose: true,
      timeout: 5000,
      iconClass: 'fa-times-circle',
    });
  }

}
